"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALL_CASHIER_PERMISSIONS = exports.CashierPermissions = void 0;
/**
 * Permission string catalog for the Cashier workflow (Stage 13,
 * Milestone 2 Part 3) — cash-drawer shift open/close/approve only. Cash
 * Counter master CRUD and Cash Book/Summary reads live under
 * `CashManagementPermissions` instead; Bank-side actions live under
 * `BankManagementPermissions`.
 */
exports.CashierPermissions = {
    /** openSession. */
    CASHIER_SESSION_OPEN: 'cashier:session:open',
    /** closeSession (counts cash, computes variance). */
    CASHIER_SESSION_CLOSE: 'cashier:session:close',
    /** approveClose — supervisor sign-off on a large variance. */
    CASHIER_SESSION_APPROVE: 'cashier:session:approve',
    /**
     * Read frozen settlement snapshots.
     *
     * Holding it does NOT mean seeing everyone's. The same
     * `financial:op-register:view-all` that scopes every other Front Desk report
     * decides whose settlements come back — without it, this reads your own. Two
     * permissions because the questions are different: "may you see settlement
     * detail at all" and "may you see a colleague's".
     */
    CASHIER_SETTLEMENT_VIEW: 'cashier:settlement:view',
    /**
     * Accept or reject a submitted settlement — the Main Cashier's act.
     *
     * SEPARATE FROM `CASHIER_SESSION_APPROVE`, which signs off a large VARIANCE
     * so a session may finish closing. This one accepts the settlement itself:
     * the money has been handed over and the count is agreed. A supervisor may
     * legitimately hold one and not the other.
     *
     * Segregation of duties is enforced BELOW this permission, in
     * `CashSettlementSnapshotService.decide()` — a cashier cannot decide their
     * own settlement even holding this, because a permission cannot express
     * "anyone but you".
     */
    CASHIER_SETTLEMENT_ACCEPT: 'cashier:settlement:accept',
    /**
     * Read the day's transactions for verification — every counter, every user.
     *
     * DELIBERATELY NOT SCOPED TO SELF, and that is the difference from
     * `CASHIER_SETTLEMENT_VIEW`. Desk, 2026-08-28: "main cashier should verify all
     * the trsactions done all counters and all users". A verification list that
     * showed you only your own takings would be a list of transactions nobody
     * independent has looked at, which is the opposite of the control.
     */
    CASHIER_VERIFICATION_VIEW: 'cashier:verification:view',
    /**
     * Sign off a transaction, or raise an issue against it.
     *
     * SEPARATE FROM `CASHIER_SETTLEMENT_ACCEPT` because they answer different
     * questions at different grains: this one is "this individual receipt is
     * right", the other is "this drawer's total is agreed". The day cannot close
     * on the second until the first has been answered for every transaction.
     *
     * Segregation of duties is enforced BELOW the permission, in
     * `CounterVerificationService`: a cashier cannot verify a transaction they
     * collected themselves, even holding this — a permission cannot say
     * "anyone but you".
     */
    CASHIER_VERIFICATION_VERIFY: 'cashier:verification:verify',
};
exports.ALL_CASHIER_PERMISSIONS = Object.values(exports.CashierPermissions);
//# sourceMappingURL=cashier.permissions.js.map